import React, { useState } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { getDefaultHostelFoodMenu } from "../../../services/OrganisationServices/hostelManagmentService";
import { useParams } from "react-router-dom";
const HostelDefaultFoodMenuTable = () => {
  var { id } = useParams();
  return (
    <MasterTable
      getTableData={getDefaultHostelFoodMenu}
      tab1={"Hostel"}
      hostelId={id}
      tab2={"Food Menu"}
      externalPermis={{
        POST: 0,
        GET: 1,
        PUT: 0,
        DELETE: 0,
        PATCH: 0,
      }}
    />
  );
};

export default HostelDefaultFoodMenuTable;
